export class BindProdAssetsModel {
    products: Array<string> = [];
    assets: Array<string> = [];
}
